export const UPDATE_UTR_NUMBER_REQUEST = "UPDATE_UTR_NUMBER_REQUEST";
export const UPDATE_UTR_NUMBER_SUCCESS = "UPDATE_UTR_NUMBER_SUCCESS";
export const UPDATE_UTR_NUMBER_FAILURE = "UPDATE_UTR_NUMBER_FAILURE";
export const UPDATE_UTR_NUMBER_RESET = "UPDATE_UTR_NUMBER_RESET";
export const updateUtrNumberDataRequest = (payload) => ({
    type: UPDATE_UTR_NUMBER_REQUEST,
    payload,
});
export const updateUtrNumberDataSuccess = (payload) => ({
    type: UPDATE_UTR_NUMBER_SUCCESS,
    payload,
});
export const updateUtrNumberDataFailure = (error) => ({
    type: UPDATE_UTR_NUMBER_FAILURE,
    payload: error,
});
export const updateUtrNumberDataReset = () => ({
    type: UPDATE_UTR_NUMBER_RESET,
});
